import {
  SET_CATEGORY,
  SET_DROPDOWN_OPTIONS,
  SET_HEADERS,
  SET_ROW_HEADERS,
  SET_TYPES,
  SET_ROW_TYPES,
} from "constants/questionSetConst/questionSetConst";

const initial_state = {
  headers: [],
  rowHeaders: [],
  types: [],
  rowTypes: [],
  category: [],
  dropdownOptions: {},
  groupConfig: {
    column: [],
    row: [],
  },
  rowTitle: "",
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case SET_HEADERS:
      return (state = { ...state, headers: action.payload });
    case SET_ROW_HEADERS:
      return (state = { ...state, rowHeaders: action.payload });
    case SET_TYPES:
      return (state = { ...state, types: action.payload });
    case SET_ROW_TYPES:
      return (state = { ...state, rowTypes: action.payload });
    case SET_CATEGORY:
      return (state = { ...state, category: action.payload });
    case SET_DROPDOWN_OPTIONS:
      return (state = { ...state, dropdownOptions: action.payload });
    case "GROUP_CONFIG":
      return (state = { ...state, groupConfig: action.payload });
    case "ROW_TITLE":
      return (state = { ...state, rowTitle: action.payload });

    default:
      return state;
  }
}
